<template>
  <div>
    <transition name="fade" mode="out-in">
      <lottie v-if="!checkAnimationFinished" :options="defaultOptions" :height="400" :width="400" v-on:animCreated="handleAnimation"/>
      <div v-if="showRes">
        <h1 class="title mqu-subtitle">Ok! We're done! Here are your results.</h1>
        <article class="content">
          <ul>
            <li>We estimate that a person of your age and gender is likely to live in the village for an <strong>average term of {{value.response.expected_healthy_lifespan}} years</strong>.</li>
            <li>Your stay in the village could be longer or shorter than this. Your health may be above or below average.</li>
            <li>We estimate this village will cost you <strong>{{value.response.expected_healthy_lifespan_year_rent_per_month | currency}} per month over the {{value.response.expected_healthy_lifespan}} year term</strong>.</li>
            <li>This is a "comparison rent" taking account of all the fees, any refund/resale value after you leave and the term of your stay.<br>You can use the comparison rent to compare different deals on offer.</li>
            <li>You should seek financial and legal advice before making any decisions about RV contracts.</li>
          </ul>
        </article>
      </div>
    </transition>
  </div>
</template>

<script>
import Lottie from 'vue-lottie'
import CheckAnimation from '../../../assets/CheckAnimation'

export default {
  props: ['value', 'loading'],
  components: {
    Lottie
  },
  data() {
    return {
      defaultOptions: { animationData: CheckAnimation, loop: false },
      animationSpeed: 1,
      anim: null,
      showRes: false
    }
  },
  methods: {
    handleAnimation: function(anim) {
      this.anim = anim
    }
  },
  computed: {
    checkAnimationFinished: function() {
      if (this.anim) {
        if (this.anim.isPaused) {
          return true
        }
      }
      return false
    }
  },
  watch: {
    checkAnimationFinished: function(value) {
      if (value === true) {
        this.showRes = true
      } else {
        this.showRes = false
      }
    }
  }
}
</script>

<style scoped>
.mqu-title {
  font-family: 'National-Extrabold';
}

.mqu-subtitle {
  font-family: 'National-Light';
}
</style>



// WEBPACK FOOTER //
// src/components/modules/stages/ResultA.vue